import { render } from "./AdminComicsPage.vue?vue&type=template&id=0ce8ccbc&scoped=true"
import script from "./AdminComicsPage.vue?vue&type=script&lang=js"
export * from "./AdminComicsPage.vue?vue&type=script&lang=js"

import "./AdminComicsPage.vue?vue&type=style&index=0&id=0ce8ccbc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ce8ccbc"]])

export default __exports__